<template>
    <div>
        <div v-if="is_loading">
            <img src="/img/loading.gif">
        </div>
        <div v-else class="login_block">
            <div class="c-login-method">
                <label class="btn-login-method" :class="{'btn-login-method--active':method==selected_method}" v-for="(method, key) in available_methods" :key="key">
                    <input type="radio" :value="method" v-model="selected_method">{{method}}
                </label>
            </div>

			<div class="login_frame" v-if="selected_method_key === 'register_with_address'">
                <div v-if="is_metamask">
                    <div v-if="account==undefined">
                        <p class="c-login-box__description">{{$t("auth.register_with_address")}}</p>
                        <button class="btn-loginform" @click="ConnectMetamask">{{$t("auth.connect")}}</button>
                    </div>
                    <div class="c-login-acceptwallet">
                        <p class="c-login-acceptwallet__number"><span>{{(account!=undefined)?account:""}}</span></p>
                        <p class="c-login-acceptwallet__alert" v-if="!is_connected">{{$t("auth.accept_first")}}</p>
                    </div>
                    <div class="c-login-submit">
                        <button class="btn-loginform" @click="signbyWallet" :disabled="!is_connected">{{$t("auth.login")}}</button>
                    </div>
                </div>
                <div v-else>
                    <p>{{$t("auth.connect_first")}}</p>
					<div v-if="isMobile" class="c-login-method">
						<div  class="form-check btn-login-method">
							<a href="https://metamask.app.link/dapp/blockchaingame.jp/">Open MetaMask</a>
						</div>
					</div>
                    <div v-else>
                        <div class="c-login-submit">
                            <button class="btn-loginform" :disabled=true>{{$t("auth.login")}}</button>
                        </div>
                    </div>
                    <p>{{$t("auth.connect_is_fun")}}</p>
                </div>
            </div>

            <div class="login_frame" v-else-if="selected_method_key === 'email'">
                <form method="POST" action="/login">
                    <input type="hidden" name="_token" :value="_token">
                    <div class="c-form-login__item">
                        <div class="c-form-login__name">
                            <label class="c-form-login__label">{{ $t('auth.email') }}</label>
                        </div>
                        <div class="c-form-login__field">
                            <input id="email" type="email" class="c-form-input" name="email" value="" required autofocus>
                        </div>
                    </div>
                    <div class="c-form-login__item">
                        <div class="c-form-login__name">
                            <label class="c-form-login__label">{{ $t('auth.password') }}</label>
                        </div>
                        <div class="c-form-login__field">
                            <input id="password" type="password" class="c-form-input" name="password" required>
                        </div>
                    </div>
                    <div class="c-login-submit">
                        <p class="c-login-submit__l-agreement">
                            <label class="c-form-agreement" for="agreement">
                                <a href="/page/attention">{{$t('auth.login_agree')}}</a>に同意の上ご利用ください
                            </label>
                        </p>
                        <div class="c-login-submit__btn">
                            <button type="submit" class="btn-loginform">
                                {{ $t('auth.login') }}
                            </button>
                        </div>
                    </div>
                    <div class="c-login-navi">
                        <div class="c-login-navi__l-link">
                            <a class="c-login-navi__link" href="/register">{{ $t('auth.register') }}</a>
                        </div>
                        <div class="c-login-navi__l-link">
                            <a class="c-login-navi__link" href="/password/reset">{{ $t('auth.forget_password') }}</a>
                        </div>
                    </div>
                </form>
            </div>

            
            
        </div>
    </div>
</template>

<script>
/* eslint-disable no-console */
const Web3=require("web3");
const DappAuth = require('@dapperlabs/dappauth');
const dappAuth = new DappAuth(window.ethereum);

export default({
	data(){
		return{
			account:undefined,
			messages:null,
			sign:null,
			web3:null,
			connectable:true,
			wallets:[],
			current_id:0,
			disabled:true,
			is_loading:false,
			is_metamask:false,
			is_connected:false,
			//selected_method:"ウォレットでログイン",
			selected_method_key: "register_with_address", // デフォルトはウォレットログイン
			//available_methods:["ウォレットでログイン","メールアドレスでログイン"],
			//selected_method: "",
			//available_methods: [],
			_token:null
		}
	},
	props:["user"],
	mounted() {

		this.InitData();
	},
	computed: {
        selected_method: {
            get() {
				const value = this.$t(`auth.${this.selected_method_key}`);
				console.log('selected_method get:', this.selected_method_key, '->', value);
				return value;
            },
			set(value) {
            console.log('selected_method set:', value);
            if (value === this.$t('auth.register_with_address')) {
                this.selected_method_key = 'register_with_address';
            } else if (value === this.$t('auth.email')) {
                this.selected_method_key = 'email';
            }
            console.log('selected_method_key changed to:', this.selected_method_key);
        }
        },
		available_methods() {
        const methods = [
            this.$t('auth.register_with_address'),
            this.$t('auth.email')
        ];
        console.log('available_methods:', methods);
        return methods;
    }
    },
	watch:{
		'web3':async function(){
			this.getAccount();
		},
		'account':function(){
			if(this.account!='undefined'){
				this.connectable=false;
			}
		},

	},
	methods:{
		//
		async InitData(){
			this._token=window.axios.defaults.headers.common['X-CSRF-TOKEN'];
			if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
				try {
					// ユーザーにウォレット接続をリクエスト（必要に応じて）
					// await window.ethereum.request({ method: 'eth_requestAccounts' });
					this.web3 = new Web3(window.ethereum);
					this.is_metamask = true;
					this.checkAddress();
				} catch (error) {
					this.messages = error.message;
				}
			}else if(typeof window !== 'undefined' && typeof window.web3 !== 'undefined') {
				//old metamask
				this.web3 = new Web3(window.web3.currentProvider);
				this.is_metamask=true;
				this.checkAddress();
			} else {
				//const httpEndpoint = 'http://127.0.0.1:7545'
				//this.web3 = new Web3(new Web3.providers.HttpProvider(httpEndpoint))
				this.is_metamask=false;
			}

		},

		async ConnectMetamask(){
			if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
				try {
					// ユーザーにウォレット接続をリクエスト
					const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
					this.account = accounts[0];
					this.is_connected = true;
					this.web3 = new Web3(window.ethereum);
					this.checkAddress();
				} catch (error) {
					this.messages = error.message;
				}
			} else if (typeof window !== 'undefined' && typeof window.web3 !== 'undefined') {
				// 古い MetaMask
				this.web3 = new Web3(window.web3.currentProvider);
				this.is_metamask = true;
				this.checkAddress();
			} else {
				this.is_metamask = false;
				// 必要に応じて代替プロバイダーを設定
			}

		},



		//Metamaskで署名
		async signbyWallet(){
			var message=this.web3.utils.utf8ToHex(window.axios.defaults.headers.common['X-CSRF-TOKEN']);
			await this.web3.eth.personal.sign(message,this.account).then(sign=>{
				this.loginWallet(sign);
			}).catch(error=>{
				console.log(error);
			});
		},

		//メタマスクのアドレスを取得。
		/* 
		async getAccount(){
			this.account=await this.web3.eth.getAccounts()
			.catch(error=>{
					this.is_connected=error;
					return undefined;
			}).then(accounts=>{
				if(accounts[0]!=undefined){
					this.is_connected=true;
					return accounts[0];
				}
				return undefined;
			});
		},
		*/
		async getAccount() {
            try {
                const accounts = await this.web3.eth.getAccounts();
                if (accounts.length > 0) {
                    this.account = accounts[0];
                    this.is_connected = true;
                } else {
                    this.account = undefined;
                    this.is_connected = false;
                }
            } catch (error) {
                console.error("Failed to get accounts:", error);
                this.is_connected = false;
            }
        },
		async loginWallet(sign){
			axios.post("/webapi/user/sign",{
				account:this.account,
				sign:sign,
			}).then(
				res=>{
					console.log("login success");
				if(res.data.user!=undefined){
					this.is_loading=true;
					this.$router.go({path: this.$router.currentRoute.path, force: true})
				}
			}
			);

		},
		//Addressの変更を検知する。
		checkAddress(){
			setInterval(()=>{
				this.getAccount();
			}, 5000);
		},
		isMobile() {
			var userAgent = window.navigator.userAgent.toLowerCase();
			if (
				userAgent.indexOf("iphone") != -1 ||
				userAgent.indexOf("ipad") != -1 ||
				userAgent.indexOf("android") != -1 ||
				userAgent.indexOf("mobile") != -1
			) {
				return true;
			} else {
				return false;
			}
		},

	},

});


</script>